<template>
	
		<div class="row pt-4 pb-5 pl-5 pr-5" v-if="isLoaded">
			<div v-for="category in elements" :key="category.id" class="col-sm-12 col-md-6 dashboard-tile">

				<!-- Invitation stats colored -->
				<div class="card">
					<div class="card-body p-0">
						<h6>{{category.title}}</h6>
						<h3 >{{category.count}}</h3>
					</div>
				</div>
			</div>
		</div>
</template>
<script>

import  ui  from '@components/ui'

export default {
	name: 'Stats',
	props: {
		stats : {
            type: Array,
            default : function(){
				return []
			}
		}
    },
	components : {
	},
	data() {
		return {
			loading : {
            	status : false,
            	message : 'Loading ...',
			},
			isLoaded : false,
			elements: [],
		    errors : {},
		}
	},
	watch: {
        
    },
	mounted(){
		this.initialize();
	},
	computed: {
		isLoading : function () {
    		return this.loading.status
    	},
    	hasElements : function(){
            return this.elements.length > 0;
        },
	},

	methods: {
		initialize() {
			this.elements = this.stats
			this.isLoaded = true;
		},
		
	}
}
</script>